import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "presenterOverlayContainer",
  class: "presenter-overlay__container"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LocalVideo = _resolveComponent("LocalVideo")
  const _component_VideoVue = _resolveComponent("VideoVue")
  const _component_VueDraggableResizable = _resolveComponent("VueDraggableResizable")
  const _component_AccountBox = _resolveComponent("AccountBox")
  const _component_NcButton = _resolveComponent("NcButton")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$props.isCollapsed)
      ? (_openBlock(), _createBlock(_component_VueDraggableResizable, {
          key: 0,
          ref: "presenterOverlay",
          parent: "",
          class: "presenter-overlay",
          resizable: false,
          h: $data.presenterOverlaySize,
          w: $data.presenterOverlaySize,
          x: $setup.isDirectionRTL ? $setup.parentWidth - $data.presenterOverlaySize - 10 : 10,
          y: 10,
          onDragging: _cache[2] || (_cache[2] = $event => ($data.isDragging = true)),
          onDragstop: _cache[3] || (_cache[3] = $event => ($data.isDragging = false))
        }, {
          default: _withCtx(() => [
            ($props.isLocalPresenter)
              ? (_openBlock(), _createBlock(_component_LocalVideo, {
                  key: 0,
                  class: "presenter-overlay__video",
                  token: $props.token,
                  "local-media-model": $props.localMediaModel,
                  "local-call-participant-model": $props.model,
                  "is-presenter-overlay": "",
                  "un-selectable": "",
                  "hide-bottom-bar": "",
                  onClickPresenter: _cache[0] || (_cache[0] = $event => (_ctx.$emit('click')))
                }, null, 8, ["token", "local-media-model", "local-call-participant-model"]))
              : (_openBlock(), _createBlock(_component_VideoVue, {
                  key: 1,
                  token: $props.token,
                  class: _normalizeClass([{ dragging: $data.isDragging }, "presenter-overlay__video"]),
                  model: $props.model,
                  "shared-data": $props.sharedData,
                  "is-presenter-overlay": "",
                  "un-selectable": "",
                  "hide-bottom-bar": "",
                  onClickPresenter: _cache[1] || (_cache[1] = $event => (_ctx.$emit('click')))
                }, null, 8, ["token", "class", "model", "shared-data"]))
          ]),
          _: 1
        }, 8, ["h", "w", "x"]))
      : (_openBlock(), _createBlock(_component_NcButton, {
          key: 1,
          "aria-label": $options.t('spreed', 'Show presenter'),
          title: $options.t('spreed', 'Show presenter'),
          class: "presenter-overlay--collapsed",
          variant: "tertiary-no-background",
          onClick: _cache[4] || (_cache[4] = $event => (_ctx.$emit('click')))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_AccountBox, {
              "fill-color": "#ffffff",
              size: 20
            })
          ]),
          _: 1
        }, 8, ["aria-label", "title"]))
  ], 512))
}